import { combineReducers } from 'redux';
import areaReducer from './areaReducer';
import appReducer from './appReducer';
import stopsReducer from './stopsReducer';
import taskTypeReducer from './taskTypeReducer';
import teamReducer from './teamReducer';
import commentReducer from './commentReducer';
import areaSetupReducer from '../components/taskSetup/AreaSetup/redux/reducer';
import taskViewPageReducer from '../components/taskView/TaskViewPage/redux/reducer';
import userManagementReducer from '../components/userManagement/redux/reducer';
import engineLogViewReducer from '../components/taskView/TaskViewPage/EngineLogView/redux/reducer';
import taskCardReducer from '../components/common/taskCard/redux/reducers';
import manageTaskFormReducer from '../components/taskView/TaskViewPage/ManageTaskForm/redux/reducer';
import manageMapViewReducer from '../components/map/redux/reducer';
import logsReducer from '../components/logs/redux.js/reducer';
import roleReducer from '../components/roleManagement/redux/reducer';
import assetReducer from '../components/assetManagement/redux/reducer';
import formReducer from '../components/formManagement/redux/reducer';
import cardNavigationReducer from '../components/common/cardNavigationComponent/cardNavigationRedux';
import parentTaskCardReducer from '../components/common/parentTaskCard/parentTaskCardRedux';
import picklistReducer from '../components/picklistAndPicklistMappingManagement/picklistManagement/redux/reducer';
import contactReducer from '../components/contactManagement/redux/reducer';
import engineScheduleReducer from '../components/engineScheduleManagement/redux/reducer';
import instructionReducer from '../components/instructionManagement/redux/reducer';
import vendorReducer from '../components/vendorManagement/redux/reducer';
import globalAttributeReducer from '../components/generalConfig/attributeManagement/redux/reducer';
import approvalMatrixReducer from '../components/generalConfig/approvalMatrixManagement/redux/reducer';
import approvalTasksReducer from '../components/approvalGridView/redux/reducer';
import attachmentManagementReducer from '../components/generalConfig/attachmentManagement/redux/reducer';
import picklistMappingReducer from '../components/picklistAndPicklistMappingManagement/picklistMappingManagement/redux/reducer';
import watcherGroupReducer from '../components/generalConfig/watcherGroupManagement/redux/reducer';
import exportMangementReducer from '../components/reports/exportManagement/redux/reducer';
import analyticsReducer from '../components/reports/analyticsReport/redux/reducer';
import factorsReducer from '../components/prioritizationConfig/factors/redux/reducer';
import prioritizationModelReducer from '../components/prioritizationConfig/prioritizationModel/redux/reducer';

const rootReducer = combineReducers({
  areaReducer,
  appReducer,
  taskTypeReducer,
  teamReducer,
  commentReducer,
  stopsReducer,
  areaSetupReducer,
  taskViewPageReducer,
  userManagementReducer,
  engineLogViewReducer,
  taskCardReducer,
  manageTaskFormReducer,
  exportMangementReducer,
  manageMapViewReducer,
  logsReducer,
  roleReducer,
  assetReducer,
  formReducer,
  cardNavigationReducer,
  parentTaskCardReducer,
  picklistReducer,
  contactReducer,
  engineScheduleReducer,
  instructionReducer,
  vendorReducer,
  globalAttributeReducer,
  approvalMatrixReducer,
  approvalTasksReducer,
  attachmentManagementReducer,
  picklistMappingReducer,
  watcherGroupReducer,
  analyticsReducer,
  factorsReducer,
  prioritizationModelReducer,
});

export default rootReducer;
